import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, TextField } from "@mui/material";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";
import { customTheme } from "../../../assets/scss/theme/Theme";
import { ThemeProvider } from "@mui/material/styles";
import * as CommonStyles from "./CommonStyles";
import "./CommonStyles.scss";

interface Props {
  name: string;
  title: string;
  description: string;
  controls: any;
  values?: any;
  onChange: any;
  width?: number;
  defaultValue: number;
}

const SliderInput: FC<Props> = ({
  name,
  title,
  description,
  controls = {},
  values = {},
  onChange,
  defaultValue
}) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(defaultValue);

  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setValue(newValue as number);
    onChange(event, name, controls.name);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value === "" ? 0 : Number(event.target.value));
    onChange(event, name, controls.name);
  };

  const handleBlur = () => {
    if (value < controls.min) {
      setValue(controls.min);
    } else if (value > controls.max) {
      setValue(controls.max);
    }
  };

  return (
    <Box className="filter-section multiple-input-control">
      <h4 style={CommonStyles.titleElement}>{t(title)}</h4>
      <Typography sx={CommonStyles.descriptionElement}>
        {t(description)}
      </Typography>

      <Box className="SliderBox">
        <Slider
          key={`slider-${name}-numeric-${controls.name}`}
          defaultValue={defaultValue}
          value={value}
          onChange={handleSliderChange}
          aria-labelledby="input-slider"
          className="slider"
          min={controls.min}
          max={controls.max}
          color="secondary"
          sx={{
            "& .MuiSlider-rail": {
              color: "#F2F2F2"
            },
            "& .MuiSlider-thumb": {
              "box-shadow": "0px 2px 2px 0px rgba(0, 0, 0, 0.15)"
            }
          }}
        />
        <TextField
          key={`input-${name}-numeric-${controls.name}`}
          name={name}
          value={value}
          size="small"
          className="slider-inputbox"
          onChange={handleInputChange}
          onBlur={handleBlur}
          inputProps={{
            min: controls.min,
            max: controls.max,
            type: "number",
            "aria-labelledby": "input-slider"
          }}
        />
      </Box>
    </Box>
  );
};

export default SliderInput;
